export const layoutTypeConstants = {
    TEXT: "TEXT",
    PHOTO: "PHOTO",
};  